/**
 * A refresh credential is not disproved by transport pressure. Keep the
 * current browser session while those failures retry; every malformed
 * success envelope and non-retryable client response remains fail-closed.
 */
export function isTransientRefreshFailure(error) {
  const status = Number(error?.status) || 0;
  const code = String(error?.code || "");
  return (
    code === "network_error" || status === 408 || status === 425 || status === 429 || status >= 500
  );
}
